// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartlineContainerStyles } from "@guestsupply/App/Components/Cart/CartLineContainer";
import { avoidBreakInsidePrintElement, color, getSystemColor, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

cartlineContainerStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 91px 3fr 1.5fr 1fr 1.5fr 22px;
        grid-column-gap: 15px;
        background: ${color("common.background")};
        border-bottom: 1px solid ${color("common.border")};
        padding: 12px 12px 16px;
        width: 100%;
        ${avoidBreakInsidePrintElement}
        @media print {
            width: 100%;
            content: "";
            display: table;
            clear: both;
            border-bottom: 1px solid ${getSystemColor("common.border")};
        }
        ${xScreen("lte", "md")} {
            grid-row-gap: 8px;
            padding: 12px 0 8px;
        }
    `,
};
cartlineContainerStyles.promotion = {
    css: css`
        display: flex;
        background-color: ${color("success.light")};
        border-radius: 2px;
        padding: 12px;
        margin-top: 16px;
        width: fit-content;

        &:empty {
            display: none;
        }
    `,
};
cartlineContainerStyles.image = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 1 / 4;
        ${xScreen("lte", "md")} {
            grid-row: 1 / 3;
        }
        @media print {
            max-width: 18%;
            min-height: 120px;
            margin-bottom: 32px;
            margin-right: 12px;
            float: left;
        }
    `,
};
cartlineContainerStyles.description = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 1 / 3;
        position: relative;
        display: flex;
        flex-direction: column;
        ${xScreen("lte", "md")} {
            grid-column: 2 / 6;
            grid-row: 1 / 3;
        }
        @media print {
            min-width: 75%;
            max-width: 75%;
            min-height: 120px;
            float: left;
        }
    `,
};
cartlineContainerStyles.price = {
    css: css`
        grid-column: 3 / 4;
        grid-row: 1 / 3;
        position: relative;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 7;
            grid-row: 3 / 4;
        }
        @media print {
            min-width: 25%;
            min-height: 50px;
            float: left;
        }
    `,
};
cartlineContainerStyles.qty = {
    css: css`
        grid-column: 4 / 5;
        grid-row: 1 / 3;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
            grid-row: 4 / 5;
        }
        @media print {
            margin-right: 0;
            min-width: 22%;
            min-height: 50px;
            float: left;
        }
    `,
};
cartlineContainerStyles.total = {
    css: css`
        grid-column: 5 / 6;
        grid-row: 1 / 3;
        position: relative;
        ${xScreen("lte", "md")} {
            grid-column: 3 / 7;
            grid-row: 4 / 5;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
        @media print {
            min-width: 35%;
            min-height: 50px;
            float: right;
        }
    `,
};
cartlineContainerStyles.remove = {
    css: css`
        grid-column: 6 / 7;
        grid-row: 1 / 3;
        display: flex;
        align-items: baseline;
        justify-content: center;
        ${xScreen("lte", "md")} {
            justify-content: end;
        }
    `,
};

cartlineContainerStyles.actions = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 3 / 4;
        position: relative;
        display: flex;
        flex-direction: column;
        margin-top: 4px;

        &:empty {
            display: none;
        }
        ${xScreen("lte", "md")} {
            grid-column: 1 / 7;
            grid-row: 5 / 6;
        }
        ${xScreen("lte", "xs")} {
            grid-row: 5 / 6;
        }
    `,
};
cartlineContainerStyles.notes = {
    css: css`
        grid-column: 2 / 7;
        grid-row: 4 / 5;
        position: relative;
        &:empty {
            display: none;
        }
        ${xScreen("lte", "md")} {
            grid-column: 1 / 7;
            grid-row: 6 / 7;
        }
        ${xScreen("lte", "xs")} {
            grid-row: 7 / 8;
        }
        @media print {
            min-width: 100%;
            float: left;
        }
    `,
};

cartlineContainerStyles.poNumber = {
    css: css`
        grid-column: 1 / 7;
        grid-row: 2 / 3;
        display: inline-flex;
        align-items: center;
        justify-content: flex-end;
        gap: 42px;

        &:empty {
            display: none;
        }

        ${xScreen("lte", "md")} {
            grid-row: 5 / 5;
            justify-content: space-between;
            margin-top: 4px;
        }
    `,
};
